module.exports = __webpack_public_path__ + "ebfd526a521a8516026f8e22e12733bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/rauchverband/R4.jpg
// module id = 370
// module chunks = 0